<template lang="pug">
  div.ma-auto(style="width:1000px;")
    div.text-right.py-5
      el-button(type="primary" @click="$router.go(-1)") 返回
      el-button(type="primary" v-print="'#print'") 打印
    div#print.w-100
      el-row.mx-0
        el-col.text-center(:span="24")
          div.subheading.mb-2 {{head.org_name}}
      el-row.mt-1.mx-0
        el-col(:span="24")
          div.caption 供货单位：{{head.supplier_name}}
      el-row.mx-0
        el-col(:span="24")
          div.caption(style="text-indent: 2em;") 为保证我公司与贵公司往来账项一致，特出具此对账单询证，烦请贵公司根据账务情况进行核对，若信息无误，请在下方确认处签字并盖章。
      el-row.mx-0(type="flex" justify="end")
        el-col(:span="9")
          div.caption 起止日期：{{head.begin_date}}&nbsp;至&nbsp;{{head.end_date}}
        el-col(:span="2")
          div.caption 单位：元
      //- div.w-100.my-8(style="border-top:4px solid #000")
      table#table.w-100.text-center.mt-1(cellspacing="0")
        thead
          tr
            th(rowspan="2") 对账类别
            th(rowspan="2") 期初欠款
            th(colspan="2") 本期采购
            th(rowspan="2") 本期付款
            th(rowspan="2") 期末欠款
            th(rowspan="2") 期末未到发票
          tr
            th(style="border-top: 1px solid #333;") 数量
            th(style="border-top: 1px solid #333;border-right: 1px solid #333;") 金额
        tbody
          tr
            td(width="100") {{head.classification}}
            td.text-right {{head.before_debt}}
            td.text-right(width="100") {{head.current_num}}
            td.text-right(width="100") {{head.current_money}}
            td.text-right(width="100") {{head.current_pay}}
            td.text-right {{head.after_debt}}
            td.text-right {{head.after_no_invoice}}
      div.mt-1
        div.caption 备注：1、以上未到票金额需要开具13%增值税专用发票。
        div(style="text-indent: 3em;").caption 2、期末未到发票表示我公司尚未收到贵公司的发票金额。
        div(style="text-indent: 3em;").caption 3、本对账单仅为复核双方账目之用，不做其他商业用途，若款、货、票在上述日期之后已结清，仍请及时回复为盼。
        div(style="text-indent: 3em;").caption 4、本公司传真号码：xxxx   手机：{{head.contact_phone}}
        div(style="text-indent: 3em;").caption 5、收到对账单后，请于2日内签字盖章并回传，谢谢配合。
      el-row.mx-0(:gutter="10")
        el-col(:offset="1" :span="10")
          div.caption.mt-1 本公司确认信息无误
          div.caption.mt-1 确认单位（加盖财务章或公章）
          div.w-100.mt-1
            el-row.caption(type="flex" justify="end")
              el-col(:span="4") 年             
              el-col(:span="4") 月 
              el-col(:span="4") 日
          div.w-100.mt-1
            el-row
              el-col.caption(:offset="12" :span="6") 经办人：
        el-col(:offset="2" :span="10")
          div.caption.mt-8   
          div.caption.mt-1.text-right 购货单位：{{head.org_name}}
          div.w-100.mt-1
            el-row.caption(type="flex" justify="end")
              el-col(:span="4") 日期：
              el-col(:span="2").text-right 年             
              el-col.text-right(:span="3") 月 
              el-col.text-right(:span="3") 日
</template>
<script>
export default {
  data() {
    return {
      data: {},
      head: {},
      body: [],
      loading: false
    };
  },
  props: ["id"],
  methods: {
    async getById() {
      this.loading = true;
      let res = await this.$api.account_statement.getById(this.id);
      this.loading = false;
      if (res) {
        this.data = res.data;
        this.head = res.data.head;
        this.body = res.data.body;
      }
    }
  },
  created() {
    this.getById();
  }
};
</script>
<style scoped>
#table {
  border: 1px solid #333;
  font-size: 12px;
}
#table th,
#table td {
  height: 28px;
  padding: 2px 5px;
  min-width: 50px;
  font-weight: 300;
}
#table th {
  border-right: 1px solid #333;

}
#table th:last-child,
#table td:last-child {
  border-right: 0px;
}
#table td {
  border-top: 1px solid #333;
  border-right: 1px solid #333;
}
.body-1,.caption {
  font-weight:300 !important;
}
</style>